<template>
    <section class="m-poverty">
        <section class="m-banner">
            <img src="../../assets/images/poverty/banner.jpg" alt="">
        </section>
        <section class="nav-poverty">
            <router-link to="/poverty">
                <div class="icon">
                    <img src="../../assets/images/poverty/nav_ico_4.png" alt="">    
                </div>
                <div class="name">脱贫成就</div>
            </router-link>
            <a href="http://sub.gxnews.com.cn/subject/2020/tuopin/">
                <div class="icon">
                    <img src="../../assets/images/poverty/nav_ico_3.png" alt="">    
                </div>
                <div class="name">脱贫攻略</div>
            </a>
            <router-link to="/gxnews/more/51123">
                <div class="icon">
                    <img src="../../assets/images/poverty/nav_ico_1.png" alt="">    
                </div>
                <div class="name">“益”起脱贫</div>
            </router-link>
            <router-link to="/gxnews/more/51119">
                <div class="icon">
                    <img src="../../assets/images/poverty/nav_ico_2.png" alt="">    
                </div>
                <div class="name">幸福新广西</div>
            </router-link>
        </section>
        <section class="m-floor-1 floor">
            <dl v-for="(item,index) in readingdata.slice(0,3)" :key="index">
                <dt v-bind:class="item.img ? '' : 'fillwidth'">
                    <a :href="item.url">
                        <div class="title">
                            <span v-if="item.enclitic">直播</span>
                            {{item.title}}
                        </div>
                        <div class="from">{{item.source}} <span>{{item.humantime}}</span></div>
                    </a>    
                </dt>
                <dd v-if="item.img">
                    <img :src="item.img" alt="">
                </dd>
            </dl>
        </section>

        <section class="m-floor-2 floor">
            <h2>
                <div class="title">
                    <img src="../../assets/images/poverty/title.png" alt="">
                </div>
                <router-link to="/gxnews/more/51124"></router-link>
            </h2>
            <swiper :options="swiperOptionTour">
                <swiper-slide v-for="(item,index) in videos" :key="index">
                    <div class="list">
                        <a :href="item.url">
                            <div class="pic">
                                <i></i>
                                <div class="mark"></div>
                                <img :src="item.img" alt="">
                            </div>
                            <div class="check">
                                <img src="../../assets/images/poverty/check.png" alt="">
                            </div>
                        </a>    
                    </div>
                </swiper-slide>
            </swiper>
        </section>
        <section class="m-floor-3 floor">
            <ul>
                <li v-for="(item,index) in readingdata.slice(3,20)" :key="index">
                    <dl>
                        <dt v-bind:class="item.img ? '' : 'fillwidth'">
                            <a :href="item.url">
                                <div class="title">
                                    <span v-if="item.enclitic">H5</span>
                                    {{item.title}}
                                </div>
                                <div class="from">{{item.source}} <span>{{item.humantime}}</span></div>
                            </a>    
                        </dt>
                        <dd v-if="item.img">
                            <img :src="item.img" alt="">
                        </dd>
                    </dl>   
                </li>
            </ul>
            <div class="more">
                    <router-link to="/gxnews/more/51117">点击查看更多<i></i></router-link>   
            </div>
            <div class="m-ad">
                <a href="http://sub.gxnews.com.cn/subject/2020/tuopin/">
                    <img src="../../assets/images/poverty/ad.jpg" alt="">
                </a>
            </div> 
        </section>
    </section>
</template>

<script>
    import jsonp from 'jsonp'
    import {swiper , swiperSlide} from 'vue-awesome-swiper'
    
    export default {
        data(){
            return{
                navs:[
                    {icon: require('../../assets/images/poverty/nav_ico_1.png'), name: '“益”起脱贫'},
                    {icon: require('../../assets/images/poverty/nav_ico_2.png'), name: '幸福新广西'},
                    {icon: require('../../assets/images/poverty/nav_ico_3.png'), name: '脱贫专题'},
                    {icon: require('../../assets/images/poverty/nav_ico_4.png'), name: '脱贫成就展'},
                ],
                readingdata: [],
                videos:[],
                swiperOptionTour:{
                    slidesPerView: 1.8
                }
            }
        },
        created(){
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51117&start=0&limit=20', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("readingdata",data);
                    this.readingdata = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51124&start=0&limit=6', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("shipin",data);
                    this.videos = data;
                }
            })
        }    
    }
</script>

<style lang="less" scoped>
    .swiper-container{
        overflow: inherit;
    }
    .floor{
        padding: 0 0.3rem;
    }
    .m-banner{
        img{
            width: 100%;
        }
    }
    .nav-poverty{
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        flex-wrap: wrap;
        border-bottom: 0.2rem solid #f4f4f4;
        padding-bottom: 0.5rem;
        a{
            text-align: center;
            flex: 1;
            font-size: 0.38rem;
            font-weight: bold;
            color: #13a880;
        }
        img{
            width: 55%;
        }
        .name{
            margin-top: 0.07rem;
        }
    }
    .m-floor-1{
        padding-top: 0.4rem;
        border-bottom: 0.1rem solid #f4f4f4;
        .fillwidth{
            width: 100%;
        }
        dl{
            overflow: hidden;
            margin-bottom: 0.45rem;
            padding-bottom: 0.4rem;
            border-bottom: 1px solid #d8d8d8;
            &:nth-last-of-type(1){
                border-bottom: none;
            }
        }
        dt{
            float: left;
            width: 65%;
            box-sizing: border-box;
            padding-right: 0.5rem;
            .title{
                color: #000;
                font-size: 0.42rem;
                margin-bottom: 0.15rem;
                span{
                    display: inline-block;
                    color: #fff;
                    vertical-align: middle;
                    padding: 0 0.15rem;
                    font-size: 0.35rem;
                    background: #68d0b4;
                    margin-right: 0.1rem;
                    border-radius: 0.1rem;
                }
            }
            .from{
                color: #929292;
                font-size: 0.32rem;
                margin-top: 0.2rem;
            }
        }
        dd{
            width: 35%;
            float: left;
            img{
                width: 100%;
                border-radius: 0.15rem;
            }
        }
    }
    .m-floor-2{
        padding-top: 0.55rem;
        h2{
            display: flex;
            margin-bottom: 0.3rem;
            span,a{
                flex: 1;
            }
            img{
                width: 70%;
                display: block;
            }
            .t1{
                width: 100%;
            }
            a{
                background: url("../../assets/images/travel/more.png") right center no-repeat;
                background-size: 40%;        
            }
        }
        .list{
            background: #fff;
            box-sizing: border-box;
            box-shadow: 0 0 0.15rem #ccc;
            padding: 0.15rem 0.1rem;
            margin-right: 0.35rem;
            .pic{
                position: relative;
                img{
                    width: 100%;
                }
                .mark{
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background: rgba(0,0,0,0.3);
                    left: 0;
                    top: 0;
                }
                i{
                    display: block;
                    position: absolute;
                    width: 1.5rem;
                    height: 1.8rem;
                    background: url("../../assets/images/poverty/play.png") no-repeat;
                    background-size: 100%;
                    left: 50%;
                    top: 50%;
                    margin: -0.8rem 0 0 -0.5rem;
                }
            }
            .check{
                margin-top: 0.5rem;
                text-align: center;
                img{
                    width: 40%;
                }
            }
        }
        .news-list{
            margin-top: 0.6rem;
            .title{
                font-size: 0.38rem;
                color: #000;
            }
            .pic-list{
                margin-top: 0.2rem;
                display: flex;
                .imgs{
                    flex: 1;
                    padding: 0.1rem;
                }
                img{
                    width: 100%;
                }
            }
            .from{
                margin-top: 0.15rem;
                font-size: 0.32rem;
                color: #949494;
            }
            .more{
                margin-top: 0.3rem;
                a{
                    display: block;
                    padding: 0 0.3rem;
                    height: 0.9rem;
                    line-height: 0.9rem;
                    text-align: center;
                    color: #ccc;
                    font-size: 0.38rem;
                    background: #f1f1f1;    
                }
                i{
                    display: inline-block;
                    width: 0.5rem;
                    height: 0.56rem;
                    background: url("../../assets/images/poverty/hand.png") no-repeat;
                    background-size: 100%;
                    vertical-align: middle;
                    margin-left: 0.05rem;
                }
            }
        }
        .m-ad{
            margin-top: 0.5rem;
            img{
                width: 100%;
            }
        }
    }
    .m-floor-3{
        padding: 0.5rem 0.3rem 1.8rem 0.3rem;
        .fillwidth{
            width: 100%;
        }
        dl{
            overflow: hidden;
            margin-bottom: 0.45rem;
            padding-bottom: 0.4rem;
            border-bottom: 1px solid #d8d8d8;
        }
        dt{
            float: left;
            width: 65%;
            box-sizing: border-box;
            padding-right: 0.5rem;
            .title{
                color: #000;
                font-size: 0.42rem;
                margin-bottom: 0.15rem;
                span{
                    display: inline-block;
                    color: #fff;
                    vertical-align: middle;
                    padding: 0 0.15rem;
                    font-size: 0.35rem;
                    background: #68d0b4;
                    margin-right: 0.1rem;
                    border-radius: 0.1rem;
                }
            }
            .from{
                color: #929292;
                font-size: 0.32rem;
                margin-top: 0.2rem;
            }
        }
        dd{
            width: 35%;
            float: left;
            max-height: 3.6rem;
            img{
                width: 100%;
                border-radius: 0.15rem;
            }
        }
        .list{
            margin-top: 0.6rem;
            .title{
                font-size: 0.38rem;
                color: #000;
            }
            .pic-list{
                margin-top: 0.2rem;
                display: flex;
                .imgs{
                    flex: 1;
                    padding: 0.1rem;
                }
                img{
                    width: 100%;
                }
            }
            .from{
                margin-top: 0.15rem;
                font-size: 0.32rem;
                color: #949494;
            }
        }
        .more{
            margin-top: 0.3rem;
            a{
                display: block;
                padding: 0 0.3rem;
                height: 0.9rem;
                line-height: 0.9rem;
                text-align: center;
                color: #ccc;
                font-size: 0.38rem;
                background: #f1f1f1;    
            }
            i{
                display: inline-block;
                width: 0.5rem;
                height: 0.56rem;
                background: url("../../assets/images/poverty/hand.png") no-repeat;
                background-size: 100%;
                vertical-align: middle;
                margin-left: 0.05rem;
            }
        } 
        .m-ad{
            margin-top: 0.5rem;
            img{
                width: 100%;
            }
        }
    }
</style>